import React, { useState } from "react";
import "./DataTable.css";

export default function DataTable({
  headers,
  data,
  keyExtractor,
  mobileRender,
  emptyState = <div className="empty-state-shared">No records found.</div>
}) {
  if (!data || data.length === 0) {
    return emptyState;
  }

  return (
    <div className="responsive-table-container">
      {/* Desktop view */}
      <div className="table-desktop-view">
        <table className="table">
          <thead>
            <tr>
              {headers.map((h, i) => (
                <th key={i} style={h.width ? { width: h.width } : undefined}>
                  {h.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={keyExtractor ? keyExtractor(row, rowIndex) : rowIndex}>
                {headers.map((h, colIndex) => (
                  <td key={colIndex}>
                    {h.render ? h.render(row, rowIndex) : row[h.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile view */}
      <div className="table-mobile-view">
        {data.map((row, rowIndex) => {
          const key = keyExtractor ? keyExtractor(row, rowIndex) : rowIndex;
          if (mobileRender) {
            return (
              <div key={key} className="mobile-row-card-wrapper">
                {mobileRender(row, rowIndex)}
              </div>
            );
          }
          return <MobileAccordionCard key={key} headers={headers} row={row} />;
        })}
      </div>
    </div>
  );
}

function MobileAccordionCard({ headers, row }) {
  const [isOpen, setIsOpen] = useState(false);
  const primaryHeader = headers[0];
  const secondaryHeaders = headers.slice(1);

  return (
    <div className={`mobile-accordion-card ${isOpen ? "open" : ""}`}>
      <div className="mobile-accordion-header" onClick={() => setIsOpen(!isOpen)}>
        <div className="mobile-accordion-primary">
          <span className="mobile-primary-label">{primaryHeader.label}</span>
          <div className="mobile-primary-value">
            {primaryHeader.render ? primaryHeader.render(row) : row[primaryHeader.key]}
          </div>
        </div>
        <span className="mobile-accordion-chevron">{isOpen ? "▲" : "▼"}</span>
      </div>
      {isOpen && (
        <div className="mobile-accordion-details">
          {secondaryHeaders.map((h, i) => (
            <div key={i} className="mobile-detail-row">
              <span className="mobile-detail-label">{h.label}</span>
              <span className="mobile-detail-value">
                {h.render ? h.render(row) : row[h.key] ?? "—"}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
